import { Component, computed, ElementRef, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { ThrottleClickDirective } from '../../directives/throttle-click.directive';
import { ButtonSize, ButtonVariant } from '../../types/button.types';

@Component({
  selector: 'ds-button',
  imports: [ThrottleClickDirective],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  public size = input<ButtonSize>('standard');
  public variant = input<ButtonVariant>('primary');
  public type = input<'button' | 'submit' | 'reset'>('button');
  public stretched = input(false);
  public disabled = input(false);
  public throttleTime = input(0);
  public formId = input<string>();
  public ariaLabel = input('');
  public ariaExpanded = input<boolean>();
  public ariaControls = input<string>();

  public clickEvent = output();
  readonly element = viewChild<ElementRef>('button');

  protected cssClasses = computed(() => [
    `ds-button--${this.size()}`,
    `ds-button--${this.variant()}`,
    this.disabled() ? 'ds-button--disabled' : '',
    this.stretched() ? 'ds-button--stretched' : '',
  ]);

  protected onClickEvent() {
    this.clickEvent.emit();
  }

  public focus() {
    this.element()?.nativeElement.focus();
  }
}
